import SamplePoint, { RawSamplePoint, SensorTagId } from 'types/models/samplePoint';

export const checkIsHeaterHost = (samplePoint: SamplePoint | RawSamplePoint): boolean => {
  // Right now only Xtend Heated Troughs have heater add-on.
  return samplePoint.sensorTags.id === SensorTagId.XTEND_HEATED_TROUGH_WATER_LEVEL;
};